export default __webpack_public_path__ + "static/media/DematIcon-w.66921877.svg";